import Vue from "vue"
import http from '../../node_modules/fe-infrastractures/src/utils/http'
import { g } from 'fe-infrastractures'
import permission from '@/router/permissionCode'

Vue.prototype.http = http
Vue.prototype.$g = g
Vue.prototype.$p = permission